// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"13a92ee7","453":"569e2f8e","732":"84df5da2","977":"3b1b1f4d"}[chunkId] + ".chunk.js";
};